;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:brandSlug\",\"regex\":\"^/([^/]+)$\",\"paramNames\":[\"brandSlug\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/admin/brands\"},{\"path\":\"/admin/brands/inbound-links\"},{\"path\":\"/demo\"},{\"path\":\"/design-test\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.2.6";import * as Sentry from "@sentry/nextjs";
import posthog from "posthog-js";

const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY?.trim();
const posthogHost = process.env.NEXT_PUBLIC_POSTHOG_HOST?.trim() || "https://us.i.posthog.com";
const posthogApiHost = process.env.NODE_ENV === "development" ? posthogHost : "/ingest";

if (posthogKey !== undefined && posthogKey.length > 0) {
	posthog.init(posthogKey, {
		api_host: posthogApiHost,
		ui_host: "https://us.posthog.com",
		defaults: "2026-01-30",
		debug: process.env.NODE_ENV === "development",
	});
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
